import { resolveApiUrl } from "~/utils/url/urlResolver";
import {
  type BearingFrequencyCalculationParams,
  type BearingFrequencyCalculationResult,
} from "~/pages/BearingFrequencyCalculatorPage/utils/calculateBearingFrequency";
import { downloadBlobFromResponse, getCsrfValue } from "~/common/utils/ApiHelper";

const url = resolveApiUrl("/bearing-frequency-calculator/calculator-result/pdf");

interface Props
  extends Pick<BearingFrequencyCalculationParams, "isInch" | "isDeg">,
    Record<keyof Omit<BearingFrequencyCalculationParams, "isInch" | "isDeg">, string>,
    Record<keyof Omit<BearingFrequencyCalculationResult, "isInch" | "isDeg">, string> {}

export const downloadBearingFrequencyPdf = async (props: Props) => {
  const response = await fetch(url, {
    body: JSON.stringify(props),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
  await downloadBlobFromResponse(response);
};
